import { render, staticRenderFns } from "./DownloadCertificate.vue?vue&type=template&id=3ca24a36&scoped=true&"
import script from "./DownloadCertificate.vue?vue&type=script&lang=js&"
export * from "./DownloadCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca24a36",
  null
  
)

export default component.exports